import type { z } from "zod";
import type { AiIdentification_LegoMinifigure_Schema, AiIdentification_Schema, AiIdentificationSummary_Schema } from "@/services/aiIdentification/aiIdentificationSchema";

export enum ErrorType {
  RateLimitReached = "rate_limit",
  ContentFilter = "content_filter",
  InsufficientQuota = "insufficient_quota",
  FakeDetected = "product_is_fake",
}

export enum ResultStatus {
  NotSentYet,
  NotFound,
  Forbidden,
  LimitReached,
  LoginRequired,
  FakeDetected,
}

export type AiIdentification = z.infer<typeof AiIdentification_Schema>;

export type AiIdentification_LegoMinifigure = z.infer<typeof AiIdentification_LegoMinifigure_Schema>;

export type AiIdentificationSummary = z.infer<typeof AiIdentificationSummary_Schema>;
